import React, { lazy, Suspense } from "react";
import "./App.css";
import { Route, Redirect, Switch, BrowserRouter } from "react-router-dom";
import Home from "./components/Home/Home";
import Navbar from "./components/Navbar/Navbar";
import Signup from "./components/Signup/Signup";
import Login from "./components/Login/Login";
import jwtDecode from "jwt-decode";
import Lgout from "./components/Logout/Logout.";
import Foods from "./components/Foods/Foods";
import Dashboard from "./components/Dashborad/Dashboard";
import Loader from "react-loader-spinner";
// import Profile from "./components/Profile/Profile";
// import FoodDetails from "./components/FoodDetails/FoodDetails";
// import Order from "./components/Order/Order";
// import ThankYou from "./components/ThankYou/ThanYou";

const Order = lazy(() => import("./components/Order/Order"));
const FoodDetails = lazy(() => import("./components/FoodDetails/FoodDetails"));
const Profile = lazy(() => import("./components/Profile/Profile"));
const ThankYou = lazy(() => import("./components/ThankYou/ThanYou"));

const App = () => {
  let user;
  try {
    const token = localStorage.getItem("token");

    user = jwtDecode(token);
  } catch (error) {}
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar user={user} />
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route
              path="/foods"
              exact
              component={() => <Foods user={user} />}
            />
            <Route path="/foods/:id" exact component={FoodDetails} />
            <Route
              path="/orders/:id"
              exact
              component={(props) => <Order props={props} user={user} />}
            />
            <Route path="/success" exact component={ThankYou} />
            <Route
              path="/dashborad"
              render={(props) => <Dashboard props={props} user={user} />}
            ></Route>

            <Route path="/signup" exact component={Signup} />
            <Route path="/login" exact component={Login} />
            <Route path="/logout" exact component={Lgout} />
            <Route
              path="/profile"
              exact
              component={() => <Profile user={user} />}
            />

            <Redirect to="/" />
          </Switch>
        </Suspense>
      </div>
    </BrowserRouter>
  );
};

export default App;
